import {
  defFetchList,
  defFetchOne,
  defUpdateOne,
  defDeleteOne
} from '@/api/default'

const BASE_PATH = '/orders_review'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function deleteOne (id) {
  return defDeleteOne(BASE_PATH, id)
}
